<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="spinner-container">
    <div id="loading-content" />
    <div class="center-loading">{{ $t('loading') }}</div>
  </div>
</template>

<script>
export default {
  name: 'EcsSpinner',
  computed: {
    CSS_VARS() {
      return {
        '--outer-color': this.theme.primary,
        '--inner-color': this.theme.secondary,
        '--bg-color': this.theme.surface,
        '--info-color': this.theme.info,
        '--success-color': this.theme.success,
        '--error-color': this.theme.error
      };
    }
  },
  data() {
    return {
      theme: {
        surface: '#444444',
        primary: '#F47920',
        secondary: '#607D8B',
        accent: '#FFC107',
        info: '#77A8DA',
        success: '#4EA96D',
        error: '#F44336',
        warning: '#FCCC4A'
      }
    };
  }
};
</script>

<style scoped>
.spinner-container {
  position: relative;
  height: 100%;
}
.center-loading {
  font-size: 24px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#long-load-time-message {
  display: block;
  position: absolute;
  top: calc(50% + 120px);
  left: calc(50% - 225px);
  color: inherit;
  width: 450px;
  text-align: center;
  font-family: 'Avenir Book', sans-serif;
  font-size: 16px;
}

#loading-content {
  display: block;
  position: relative;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  width: 200px;
  height: 200px;
  border: 3px solid var(--error-color, #f00);
}

#loading-content:after {
  content: '';
  position: absolute;
  border: 3px solid var(--success-color, #0f0);
  left: 15px;
  right: 15px;
  top: 15px;
  bottom: 15px;
}

#loading-content:before {
  content: '';
  position: absolute;
  border: 3px solid var(--info-color, #00f);
  left: 5px;
  right: 5px;
  top: 5px;
  bottom: 5px;
}

#loading-content {
  border: 3px solid transparent;
  border-top-color: var(--outer-color, #f47920);
  border-bottom-color: var(--outer-color, #f47920);
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

#loading-content:before {
  border: 3px solid transparent;
  border-top-color: gray;
  border-bottom-color: gray;
  border-radius: 50%;
  -webkit-animation: loader 3s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 3s linear infinite;
}

#loading-content:after {
  border: 3px solid transparent;
  border-top-color: var(--inner-color, #009bc3);
  border-bottom-color: var(--inner-color, #009bc3);
  border-radius: 50%;
  -webkit-animation: loader 1.5s linear infinite;
  animation: loader 1.5s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
}

@-webkit-keyframes loaders {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
